import { apiGetRequest } from 'utilities/http/api/apiHttp';
import { Nullable } from 'types';
import { ContentItemBase } from 'pricing/types';

export const apiContent = {
  getPricingContent: () =>
    apiGetRequest<{ pricingAppContent: unknown }>('breeder/pricing/content'),

  getBreedColors: (breedId: Nullable<number>) =>
    apiGetRequest<{ breedColors: ContentItemBase[] }>(`content/breed/${breedId}/colors`),
};
